import { createContext } from "react";

import { Questionnaire } from "@medplum/fhirtypes";

export const QuestionnaireContext = createContext<Questionnaire | undefined>(undefined);
